import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=0bab42ae"
import script from "./AdminOverview.vue?vue&type=script&lang=js"
export * from "./AdminOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports